import * as tslib_1 from "tslib";
import { ContentContainer } from './content_container';
var CollectionItem = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionItem, _super);
    function CollectionItem(param) {
        return _super.call(this, param) || this;
    }
    CollectionItem.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "CollectionItem" });
    };
    CollectionItem.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CollectionItem;
}(ContentContainer));
export { CollectionItem };
//# sourceMappingURL=collection_item.js.map